import { useMutation } from '@apollo/client';
import { LoanRequestCreate } from '@bakerweb/models';
import { toast } from 'react-toastify';
import { CREATE_REQUEST } from '../graphql/mutations/createRequest';

export const useCreateRequest = () => {
  const [createRequestMutation, { data, loading, error }] = useMutation(CREATE_REQUEST);

  const createRequest = async (requestData: LoanRequestCreate) => {
    const variables = {
      requestCreateDto: {
        ...requestData
      }
    };

    try {
      await createRequestMutation({ variables });
      toast.success('Your inquiry is on the way!');
    } catch (err) {
      toast.error(`There was an error sending your request. Please try again.`);
    }
  };

  return { createRequest, data, loading, error };
};
